import React from "react";
const LoadingGif = "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/gifs/loading.gif";

const SpinnerLoader = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "center",
      marginTop: '16px',
      marginBottom: '16px'
    }}
  >
    <img
      className="img-fluid"
      src={LoadingGif}
      style={{ width: "36px", height: "36px" }}
      alt="like"
    />
  </div>
);

export default SpinnerLoader;
